import React from 'react';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Horizontal frosted-glass month rail. Selected month glows forest-green.
export function MonthRail({ value, onChange }) {
  return (
    <div className="flex gap-2 overflow-x-auto hg-scroll pb-1 -mx-1 px-1">
      {MONTHS.map((m, i) => {
        const mn = i + 1;
        const on = mn === value;
        return (
          <button
            key={m}
            data-testid={`month-pill-${m.toLowerCase()}`}
            onClick={() => onChange(mn)}
            className={`hg-press flex-shrink-0 px-4 py-2 rounded-full text-sm font-semibold ${
              on
                ? 'bg-[#1A4331] text-[#FAF6EC] shadow-[0_0_18px_-2px_rgba(107,159,74,0.75)]'
                : 'hg-glass hg-glow text-[#1A4331]'
            }`}
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            {m}
          </button>
        );
      })}
    </div>
  );
}

export default MonthRail;
